<template>
  <div class="position_relative">
    <div class="padding_content" id="padding_settings" style="padding-bottom: 130px;">
      <div id="settings_container">
        <div>
          <div class="settings_content">
            <!--<img src="../assets/chat.png" alt="" class="chat">-->
            <userInfo :user="user" @updateUser="getUser"></userInfo>
            <div class="content_right">
              <h3 class="title">{{ $t('message.billing') }}</h3>
              <p class="information rtitle">
                <span>{{ $t('message.cardInformation') }}</span>
                <span v-if="cardList.length > 0" class="add" @click="changeAddCardStatus"
                  ><i class="el-icon-circle-plus-outline"></i> {{ $t('message.addNewCard') }}</span
                >
              </p>
              <div v-if="cardList.length > 0" class="cardList">
                <div class="card_information" v-for="(item, index) in cardList" :key="item.id">
                  <div class="card_left">
                    <i :class="[item.isDefault ? 'icon-checked2' : 'icon-unchecked']"></i>
                  </div>
                  <div class="card_right">
                    <div
                      class="card"
                      :style="{
                        background: 'url(' + (item.brand === 'Visa' ? imgSrc1 : imgSrc2) + ')',
                        backgroundSize: '100% 100%',
                        backgroundRepeat: 'no-repeat'
                      }"
                    >
                      <div class="right_top">XXXX XXXX XXXX {{ item.last4 }}</div>
                      <div class="right_tip">
                        {{ $t('user.Name') }}<span>{{ item.name }}</span>
                      </div>
                      <div class="right_tip ex">
                        {{ $t('user.ExpirationDate')
                        }}<span>{{ format(item.expMonth) }}/{{ item.expYear }}</span>
                      </div>
                    </div>
                    <div class="tip_blue">
                      <span
                        ><el-button type="text" @click="open(item.id)">{{
                          $t('message.delete')
                        }}</el-button></span
                      >
                      I
                      <span
                        ><el-button type="text" @click="open2(user.customerId, item.id)">{{
                          $t('message.default')
                        }}</el-button></span
                      >
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="cardList.length === 0" class="noCard">
                <img src="../../assets/img/empty_card.png" alt="" />
                <p>{{ $t('errMsg.noCard') }}</p>
                <div class="newCard" @click="changeAddCardStatus">
                  <i class="el-icon-circle-plus-outline"></i>
                  {{ $t('message.addNewCard') }}
                </div>
              </div>
              <addNewcard :show="addCardStatus" @close="close" @addCard="getCardList"></addNewcard>
            </div>
          </div>
        </div>
      </div>
    </div>
    <loading :show="cardStatus || userStatus"></loading>
    <Footer></Footer>
  </div>
</template>

<script>
import axios from 'axios'
import { Message } from 'element-ui'
import loading from '@/components/loading'
import addNewcard from './addNewcard'
import { common } from '@/views/public/common'
import userInfo from './userInfo'
import Footer from '@/components/footer'
import VueRouter from 'vue-router'

const { isNavigationFailure, NavigationFailureType } = VueRouter

export default {
  name: 'Settings',
  components: { loading, addNewcard, userInfo, Footer },
  data() {
    return {
      visaStatus: true,
      user: {},
      cardList: [],
      addCardStatus: false,
      cardStatus: true,
      userStatus: true,
      show: false,
      imgSrc1: require('../../assets/img/VISA.png'),
      imgSrc2: require('../../assets/img/master.png')
    }
  },
  methods: {
    getUser() {
      axios
        .get('/api/user')
        .then(res => {
          this.userStatus = false
          this.user = res.data
        })
        .catch(err => {
          this.userStatus = false
          this.$router.push('/login').catch(err => {
            // to hide the below error message
            if (!isNavigationFailure(err, NavigationFailureType.duplicated)) {
              throw Error(err)
            }
          })
        })
    },
    getCardList() {
      axios
        .get('/api/payment')
        .then(res => {
          this.cardStatus = false
          this.cardList = res.data || []
        })
        .catch(err => {
          this.cardStatus = false
          Message({
            type: 'error',
            message: err.response.data.statusCode + ' ' + err.response.data.message,
            showClose: true
          })
        })
    },
    setDefault(customerId, paymentId) {
      let data = {
        customerId: customerId,
        paymentId: paymentId
      }
      axios
        .post('/api/payment/default-payment', data)
        .then(res => {
          Message({ type: 'success', message: this.$t('message.setSuccessfully'), showClose: true })
          this.getCardList()
        })
        .catch(err => {
          Message({
            type: 'error',
            message: err.response.data.statusCode + ' ' + err.response.data.message,
            showClose: true
          })
        })
    },
    deleteCard(paymentId) {
      axios
        .delete('/api/payment', { data: { paymentId: paymentId } })
        .then(res => {
          Message({
            type: 'success',
            message: this.$t('message.deleteSuccessfully'),
            showClose: true
          })
          this.getCardList()
        })
        .catch(err => {
          Message({
            type: 'error',
            message: err.response.data.statusCode + ' ' + err.response.data.message,
            showClose: true
          })
        })
    },
    open(id) {
      this.$confirm(this.$t('message.deleteCard'), this.$t('message.confirm'), {
        confirmButtonText: this.$t('message.DELETE'),
        cancelButtonText: this.$t('message.CANCEL'),
        customClass: 'modal_messageBox'
      })
        .then(() => {
          this.deleteCard(id)
        })
        .catch(() => {})
    },
    open2(customerId, id) {
      this.$confirm(this.$t('message.setDefaultCard'), this.$t('message.confirm'), {
        confirmButtonText: this.$t('message.ACTION'),
        cancelButtonText: this.$t('message.CANCEL'),
        customClass: 'modal_messageBox',
        type: 'warning'
      })
        .then(() => {
          this.setDefault(customerId, id)
        })
        .catch(() => {})
    },
    changeAddCardStatus() {
      this.addCardStatus = true
    },
    close() {
      this.addCardStatus = false
    },
    changeInfoStatus() {
      this.updateInfoStatus = true
    },
    format: common.format,
    downAPP() {
      var u = navigator.userAgent
      var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1 //android终端
      var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) //ios终端
      if (document.documentElement.clientWidth < 450 && isiOS) {
        document.getElementById('padding_settings').style.paddingBottom = '200px'
      }
      if (document.documentElement.clientWidth < 450 && isAndroid) {
        document.getElementById('padding_settings').style.paddingBottom = '100px'
      }
    }
  },
  created() {
    this.getUser()
    this.getCardList()
  },
  mounted() {
    this.downAPP()
  }
}
</script>
<style lang="scss">
.modal_messageBox {
  background-color: $white;
  box-shadow: 0px 10px 24px 0px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  @include border-radius(6px);
  width: 580px !important;
  height: 169px !important;
  border: none;
  border-left: 8px solid rgba(255, 102, 0, 1) !important;
  box-sizing: border-box;
  position: absolute !important;
  left: 50% !important;
  top: 50% !important;
  transform: translate(-50%, -50%) !important;
  .el-message-box__header {
    width: 100%;
    height: 24px;
    align-items: center;
    padding: 31px 32px 12px;
    @include flex-space-between;
    /*border-bottom: 1px solid #eee;*/
    .el-message-box__title {
      font-size: 20px !important;
      font-family: NexaBold !important;
      font-weight: bold;
    }
    .el-icon-close {
      font-size: 20px;
      color: rgb(48, 49, 51);
      display: none !important;
    }
  }
  .el-message-box__content {
    position: relative;
    padding: 0 32px 33px !important;
    color: rgba(102, 102, 102, 1) !important;
    font-size: 16px !important;
    font-family: Lato-Regular !important;
    font-weight: 400;
    height: 20px;
  }
  .el-message-box__status + .el-message-box__message {
    padding-left: 0;
  }
  .el-icon-warning {
    display: none;
  }
  .el-button--small,
  .el-button--small.is-round {
    padding: 0;
    border: 0;
    border-radius: 19px;
    min-width: 80px;
    height: 17px;
    font-size: 14px !important;
    line-height: 17px;
  }

  .el-message-box__btns {
    padding-right: 20px;
    text-align: right;
    font-family: Lato-Bold !important;
    font-weight: bold;
    .el-button--default,
    .el-button--primary {
      color: $primary-color;
      background-color: transparent;
      border-color: #979797;
      &:hover {
        color: $primary-color;
        background-color: transparent;
        border-color: #979797;
      }
    }
  }
}
@media screen and (max-width: 450px) {
  .modal_messageBox {
    width: 90% !important;
    height: auto !important;
    padding-bottom: 20px !important;
    .el-message-box__content {
      padding: 0 32px 20px !important;
      height: auto;
    }
  }
}
</style>
<style lang="scss" scoped>
::v-deep .el-button--text {
  color: $primary-color;
  font-size: 12px;
  &:hover {
    color: $primary-color;
  }
}
.settings_content {
  @include flex-space-between;
  .title {
    height: 24px;
    font-size: 20px;
    font-family: NexaBold;
    color: rgba(31, 37, 62, 1);
    line-height: 24px;
  }
  .rtitle {
    width: 420px;
    @include flex-space-between;
    .add {
      font-size: 12px;
      font-weight: 500;
      color: $primary-color;
      @include flex-align-center;
      cursor: pointer;
      font-family: Roboto-Regular;
      .el-icon-circle-plus-outline {
        font-size: 16px;
        margin-right: 4px;
      }
    }
  }
  .information {
    height: 19px;
    font-size: 16px;
    font-family: NexaLight;
    color: rgba(31, 37, 62, 0.6);
    line-height: 19px;
    margin: 24px 0 32px;
  }
  .chat {
    width: 38px;
    height: 45px;
    @include absolute-right-bottom(-10px, 179px);
  }
  .content_right {
    padding: 48px 36px 30px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 4px 16px 0px rgba(0, 0, 0, 0.1);
    @include border-radius(6px);
    flex: 1;
    margin-left: 32px;
    box-sizing: border-box;
    .cardList {
      @include flex-wrap;
    }
    .card_information {
      width: 432px;
      box-sizing: border-box;
      margin-bottom: 14px;
      margin-right: 14px;
      @include border-radius(6px);
      @include flex-space-between;
      .card_left {
        margin-top: 87px;
        width: 26px;
        height: 26px;
        font-size: 25px;
        box-sizing: border-box;
        font-size: 16px;
        @include border-radius(50%);
        @include flex-center;
        & > span {
          display: inline-block;
          width: 12px;
          height: 12px;
          background: $white;
          @include border-radius(50%);
        }
        .icon-checked2 {
          color: $primary-color;
        }
        .icon-unchecked {
          font-weight: 900;
          color: #d2d3d8;
        }
      }
      .card_right {
        width: 400px;
        .card {
          width: 400px;
          height: 214px;
          box-sizing: border-box;
          @include border-radius(6px);
        }
        .right_top {
          height: 24px;
          line-height: 24px;
          padding: 69px 0;
          text-align: center;
          font-size: 20px;
          font-family: Lato-Bold;
          font-weight: bold;
          color: $white;
          box-sizing: border-box;
        }
        .right_tip {
          font-size: 14px;
          color: rgba(255, 255, 255, 0.4);
          height: 17px;
          line-height: 17px;
          font-family: Lato-Regular;
          color: rgba(255, 255, 255, 0.6);
          font-weight: 400;
          padding-left: 30px;
          box-sizing: border-box;
          & > span {
            margin-left: 16px;
            font-family: Lato-Bold;
            font-weight: bold;
          }
        }
        .ex {
          margin-top: 7px;
        }
        .tip_blue {
          width: 390px;
          height: 14px;
          line-height: 14px;
          font-size: 12px;
          font-family: Roboto-Regular;
          font-weight: 400;
          word-spacing: 8px;
          margin: -15px 0 20px;
          text-align: right;
          color: $primary-color;
          & > span {
            cursor: pointer;
            &:hover {
              color: $primary-color;
            }
          }
        }
      }
    }
    .noCard {
      & > img {
        width: 88px;
        height: 88px;
        margin: 0 auto;
        display: block;
      }
      & > p {
        text-align: center;
        margin: 8px 0 24px;
        color: rgba(31, 37, 62, 0.3);
        font-size: 14px;
        font-family: Lato-Regular;
        font-weight: 400;
        height: 17px;
        line-height: 17px;
      }
      .newCard {
        width: 160px;
        height: 40px;
        box-sizing: border-box;
        box-shadow: 0px 4px 16px 0px rgba(255, 103, 0, 0.3);
        color: $white;
        background: $primary-color;
        @include border-radius(20px);
        @include flex-center;
        font-size: 12px;
        cursor: pointer;
        font-family: Roboto-Bold;
        font-weight: bold;
        margin: 0 auto;
        .el-icon-circle-plus-outline {
          font-size: 16px;
          margin-right: 4px;
        }
      }
    }
  }
}
@media screen and (max-width: 1313px) {
  .settings_content {
    display: block;
    .content_right {
      width: 100%;
      margin-left: 0;
      margin-bottom: 30px;
    }
  }
}

@media screen and (max-width: 450px) {
  .settings_content {
    .rtitle {
      width: 100%;
    }
    .content_right {
      .card_information {
        width: 100%;
        margin-right: 0;
        display: block;
        position: relative;
        .card_left {
          @include absolute-right-top(16px, 16px);
          margin-top: 0;
          .icon-checked2 {
            color: $white;
          }
          .icon-unchecked {
            display: none;
          }
        }
        .card_right {
          width: 100%;
          .card {
            width: 100%;
            height: 170px;
          }
          .right_top {
            font-size: 18px;
            padding: 50px 0;
          }
          .tip_blue {
            width: 98%;
          }
        }
      }
    }
  }
}
@media screen and (max-width: 325px) {
  .settings_content {
    .information {
      font-size: 12px;
    }
    .content_right .card_information .card_right {
      .card {
        height: 150px;
      }
      .right_top {
        font-size: 14px;
        padding: 50px 0 40px;
      }
      .right_tip {
        font-size: 12px;
        padding-left: 15px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/settings/settings.vue